import { createStyles, Theme } from '@material-ui/core';

export default (theme: Theme) => createStyles({
  form: {
    width: '100%',
    height: '100%',
    padding: '16px 24px',
    backgroundColor: '#f4f5f6',
  },
  content: {
    height: '100%',
  },
  stickyFooter: {
    position: 'sticky',
    bottom: 0,
    backgroundColor: '#fff',
    padding: '16px 0',
    zIndex: 2,
    borderTop: '1px solid #ccc',
  },
});
